import { createSlice, createSelector } from '@reduxjs/toolkit'

import { getConfigUpdateInterval, getOfflineTimeFilter, getApiRoot } from './configSlice'

import SpecTransportsDataStore from "../services/dataStores/specTransports";

const REDUCER_KEY = 'transport'
export const TRANSPORT_REDUCER_KEY = REDUCER_KEY

const slice = createSlice({
    name: REDUCER_KEY,
    initialState: {
        ready: false,
        error: false,
        data: [],
    },
    reducers: {
        setTransports: (state, { payload }) => {
            state.ready = true
            state.error = false

            payload.forEach(({ id, number, time, lat, lng, speed, company, iconUrl, type, atGarage }, i) => {
                const currTransport = state.data[i]

                if (
                    !currTransport
                    || currTransport.number !== number
                    || currTransport.time !== time
                    || currTransport.lat !== lat
                    || currTransport.lng !== lng
                    || currTransport.speed !== speed
                    || currTransport.company !== company
                    || currTransport.iconUrl !== iconUrl
                    || currTransport.type !== type
                ) {
                    state.data[i] = { id, number, atGarage, time, lng, lat, speed, company, iconUrl, type }
                }
            })

            if (state.data.length > payload.length) {
                state.data.length = payload.length
            }
        },
        setTransportsError: (state) => {
            state.error = true
        },
    },
})

export const {
    setTransports,
    setTransportsError,
} = slice.actions

export const fetchTransports = () => async (dispatch, getState) => {
    try {
        let state = getState()
        const apiRoot = getApiRoot(state)
        const specTransportsDataStore = new SpecTransportsDataStore(apiRoot);

        specTransportsDataStore.loadSpecTransportsForPortal().then((res) => {
            const offlineTimeFilter = getOfflineTimeFilter(state);
            const timeLimit = (Date.now() - offlineTimeFilter) / 1000;

            const transports = res
                .filter(({ time }) => time >= timeLimit)
                .filter(
                    (item) =>
                        item.companyName &&
                        item.groupName &&
                        item.iconUrl &&
                        item.typeName
                )
                .map(
                    ({
                        id, gos_num: number, atGarage, time, lat, lng, speed, companyName: company, iconUrl, typeName: type,
                    }) => ({
                        id, number, time, atGarage, lat, lng, speed, company, iconUrl, type,
                    }),
                )
                .sort((prevTransport, nextTransport) => (nextTransport.id - prevTransport.id))

            dispatch(setTransports(transports));
        });
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
        dispatch(setTransportsError())
    }
}

export const transportsMiddleware = (store) => {
    let updateTimeout = null

    return next => (action) => {
        const prevUpdateInterval = getConfigUpdateInterval(store.getState())

        next(action)

        // Как получим конфиг в первый раз - делаем запрос за данными
        const updateInterval = getConfigUpdateInterval(store.getState())

        if (!prevUpdateInterval && updateInterval) {
            clearTimeout(updateTimeout)
            store.dispatch(fetchTransports())
        }

        if (action.type === setTransports.type || action.type === setTransportsError.type) {
            clearTimeout(updateTimeout)
            updateTimeout = setTimeout(() => {
                store.dispatch(fetchTransports())
            }, updateInterval)
        }
    }
}

const getState = state => state[REDUCER_KEY]
export const getIsTransportReady = state => getState(state).ready
export const getIsFetchError = state => getState(state).error
export const getTransports = state => getState(state).data

export const getAllCompanies = createSelector(
    getTransports,
    (transports) => {
        const companyMap = transports.reduce((acc, { company }) => {
            acc[company] = true

            return acc
        }, {})

        return Object.keys(companyMap).sort()
    },
)

export const getAllTypes = createSelector(
    getTransports,
    (transports) => {
        const typeMap = transports.reduce((acc, { type }) => {
            acc[type] = true

            return acc
        }, {})

        return Object.keys(typeMap).sort()
    },
)

export default slice.reducer
